// src/config/externalLinks.js
//
// Single source of truth for outbound URLs the platform links to. Keeping
// these in one place makes domain rebrands a one-line change instead of a
// repo-wide search-and-replace, and lets per-env overrides happen via
// Gatsby env vars (GATSBY_HELP_URL etc.).
//
// Conventions:
// - Each constant is a plain string. Consumers `import { HELP_URL } from '@/config/externalLinks'`.
// - Defaults reflect the post-rebrand ctrl-s.io brand. Env vars override
//   per build context — Netlify deploy contexts (production / staging /
//   demo) can each set their own GATSBY_HELP_URL if they need to point
//   at a different help center.
// - Both the new (`*.ctrl-s.io`) and old (`*.supplier-s.io`) help-center
//   hosts continue to resolve identically (`help.ctrl-s.io` and
//   `help.supplier-s.io` both CNAME to the same Intercom help-center
//   target), so this rebrand is purely a brand-surface flip with zero
//   user impact for either domain.

export const HELP_URL = process.env.GATSBY_HELP_URL || 'https://help.ctrl-s.io';
